<template>
  <div class="modal" :class="{ 'is-active': open }">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 560px; max-width: 95vw;">

      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('orgSetup.title') }}</p>
      </header>

      <section class="modal-card-body">
        <p class="has-text-grey mb-4">
          {{ $t('orgSetup.lead') }}
        </p>

        <div class="notification is-danger" v-if="errorMessage">
          <button class="delete" @click="errorMessage = ''"></button>
          {{ errorMessage }}
        </div>

        <div class="field">
          <label class="label">{{ $t('orgSetup.nameLabel') }} <span class="has-text-danger">*</span></label>
          <div class="control">
            <input class="input" v-model.trim="form.name" maxlength="150"
                   :placeholder="$t('orgSetup.namePlaceholder')"
                   @keyup.enter="submit">
          </div>
          <p class="help" v-if="slugPreview">
            {{ $t('orgSetup.slugPreview') }}: <code>{{ slugPreview }}</code>
          </p>
        </div>

        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t('orgSetup.taxNumber') }}</label>
              <div class="control">
                <input class="input" v-model.trim="form.taxNumber" maxlength="20">
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t('orgSetup.phone') }}</label>
              <div class="control">
                <input class="input" v-model.trim="form.phone" maxlength="30">
              </div>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('orgSetup.address') }}</label>
          <div class="control">
            <textarea class="textarea" rows="2" v-model.trim="form.address" maxlength="500"></textarea>
          </div>
        </div>

        <p class="help">
          {{ $t('orgSetup.help') }}
        </p>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-primary" :class="{ 'is-loading': saving }" @click="submit">
          {{ $t('orgSetup.submit') }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import api from '../config/api';

export default {
  name: 'OrganizationSetup',
  data() {
    return {
      open: false,
      checking: true,
      saving: false,
      errorMessage: '',
      form: { name: '', taxNumber: '', phone: '', address: '' }
    };
  },
  computed: {
    // Sunucudaki slugify ile aynı kurallar; yalnızca önizleme amaçlı,
    // gerçek değeri sunucu üretiyor ve benzersizliği orada kontrol ediliyor
    slugPreview() {
      return String(this.form.name || '')
        .toLowerCase()
        .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
        .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40);
    }
  },
  mounted() {
    this.check();
  },
  methods: {
    check() {
      api.get('/organizations/current')
        .then((body) => {
          if (body.needsSetup) {
            this.open = true;
          } else {
            this.$emit('ready', body.organization);
          }
        })
        .catch((err) => {
          // Kurum sorgusu başarısızsa pencereyi açıp kullanıcıyı
          // kilitlemek yerine sessizce geçiyoruz; asıl hata zaten
          // diğer ekranlarda görünecek
          console.error('Kurum bilgisi alınamadı:', err.message);
        })
        .then(() => { this.checking = false; });
    },

    submit() {
      if (this.saving) return;
      if (!this.form.name || this.form.name.length < 2) {
        this.errorMessage = this.$t('orgSetup.nameError');
        return;
      }

      this.saving = true;
      this.errorMessage = '';

      api.post('/organizations', this.form)
        .then((body) => {
          this.open = false;
          this.$emit('ready', body.organization);
          this.$emit('created', body.organization);
        })
        .catch((err) => { this.errorMessage = err.message; })
        .then(() => { this.saving = false; });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/Components/OrganizationSetup.vue